const offersListId = 'offers-cards';
const offersListLoadingSpinnerId = 'offers-list-loader';

export function showOffersListLoader(): void {
    document.getElementById(offersListId)!.classList.add('psf-offers__list-loading');
    document.getElementById(offersListLoadingSpinnerId)!.style.visibility = 'visible';
}

export function hideOffersListLoader(): void {
    document.getElementById(offersListId)!.classList.remove('psf-offers__list-loading');
    document.getElementById(offersListLoadingSpinnerId)!.style.visibility = 'hidden';
}